import React from 'react'
import { seriliazeParams } from '../../../helpers/seriliazeParams';
import { get_checkride_table, get_test_event_listing, view_rule_event } from '../../../Services/employee';
import { Link, useHistory } from "react-router-dom";
import moment from 'moment';
import { useEffect } from 'react';
import DynamicTable from '../../../Components/TableComponents/DynamicTable';
import { useState } from 'react';
import { checkRidesColumns, columnsForView, testingEventColumns } from '../../../Components/TableComponents/constants';
import { ValidateDate, showText } from '../../../helpers/textValidation';
import { Button } from 'antd';
import { showSnackBar } from '../../../helpers/showSnackBar';
import {
    DialogContent,
    Dialog,
    useMediaQuery,
    useTheme,

} from "@material-ui/core";
import roleManager from '../../../Components/roles';


const TestingEventTab = () => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [TestEventData, setTestEventData] = useState({ header: [], rows: [] })
    const [modalData, setModalData] = useState([])
    const history = useHistory();

    const handleAddEvent = (event, tabIndex) => {
        history.push(event);
    }
    const contractormap = (data) => {
        if (data) {
            let {
                firstName,
                lastName,
                Company
            } = data;

            let output = '';

            if (Company)
                output = Company;

            if (Company && firstName && lastName)
                output = output + "-"

            if (firstName && lastName)
                output = `${output} ${firstName} ${lastName[0]}.`

            return output;
        }

        return ''

    };
    const handleClose = () => {
        setOpen(false);
    };
    const viewTableData = {
        header: columnsForView,
        rows: modalData.map(row => [
            row?.id,
            row?.eventID,
            row?.rule_NBR,
            row?.crew_member,
            row?.result,
            row?.comment
        ])
    }

    const getTestEventData = async (offset = 0, limit = 10) => {
        let params = '?'.concat(seriliazeParams({ offset, limit }))
        let data = await get_test_event_listing({ params });
        if (data.httpStatus == 200) {
            data = data.data
            data.forEach(element => {
                element.date = ValidateDate(element?.date)
                element.time = element?.time?.slice(0, -3)
                element.locationAdded = `${showText(element?.TGSLocation?.name)}`
                element.rulesCount = `${showText(element?.TestEventRules?.length)}`
            });
            setTestEventData(
                {
                    header: testingEventColumns,
                    rows: data.map(row => [
                        row?.id,
                        row?.date,
                        row?.time,
                        row?.locationAdded,
                        row?.jobID,
                        row?.rulesCount,
                        <Link
                            to={{
                                pathname: "/add-event-rules",
                                state: { eventID: row?.id }
                            }}
                            className="EditIcon">
                            <></>
                        </Link>,
                        <Button onClick={() => handleClickOpen(row?.id)} className="ViewIcon"><></></Button>

                    ])
                }
            )
        }
    }
    const handleClickOpen = async (value) => {
        try {
            setLoading(true)
            let data = await view_rule_event({ id: value })
            if (data?.httpStatus == 200) {
                data = data?.data?.map(row => {
                    return {
                        id: row.id,
                        eventID: (row?.TestEventRule?.TestEventId) ? row.TestEventRule?.TestEventId : null,
                        rule_NBR: (row?.TestEventRule?.Rule?.RuleNo) ? row.TestEventRule?.Rule.RuleNo : null,
                        crew_member: row?.Employee
                            ? `${row.Employee.firstName} ${row.Employee.lastName}`
                            : contractormap(row?.ContractorMaster), result: (row?.result) ? row?.result : null,
                        comment: (row?.comment) ? row?.comment : null
                    }
                })
                data.sort((a, b) => {
                    return (b.id - a.id)
                })
                setModalData(data)
                setLoading(false)
            }
        } catch (error) {

            return showSnackBar(`Please Try  Again \n Error Occured while fetching data: ${error}`);
        }
        finally {
            setOpen(true);
        }
    };

    useEffect(() => {
        getTestEventData()
    }, [])
    return (
        <>
        <div style={{marginBottom:'15px'}}>
            {roleManager("safetyTesting", "CreatetestEvent") &&
                <Button
                    onClick={handleAddEvent.bind(null, 'enter-railroad-event', 0)}
                    style={{background:'#2963AD ',color:'white',borderRadius:"10px",height:'50px'}} >
                        
                    Enter Railroad Test Event
                </Button>
            } 
            </div>          
             <DynamicTable tableData={TestEventData} />
            {/* Dialog Box for This tab */}
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                className="SafetyModal LiqTables"
                aria-labelledby="responsive-dialog-title"
            >
                <Button autoFocus onClick={handleClose} className="ModalClose">
                </Button>
                <DialogContent>
                    <div className="p30">
                        <DynamicTable tableData={viewTableData} />
                    </div>
                </DialogContent>
            </Dialog>
        </>


    )
}

export default TestingEventTab
